import type { Definition } from '~/types'
import imageSizes from '../../constants/imageSizes'

const urlValidation = {
  regexp: {
    pattern: '^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?$',
    flags: null
  }
}

export const PagePodcast: Definition = {
  contentType: 'PagePodcast',
  fields: []
}

export const PagePodcastOverview: Definition = {
  contentType: 'PagePodcastOverview',
  fields: [
    {
      id: 'heroDescription',
      name: 'Hero Description',
      type: 'Text'
    },
    {
      id: 'usps',
      name: 'USPs',
      type: 'Array',
      subType: 'ModuleUsp',
      validations: [{ size: { min: 1, max: 6 } }]
    },
    {
      id: 'featuredEpisode',
      name: 'Featured Episode',
      type: 'BlockContent',
      imageOptions: { sizes: imageSizes.columns6_11, lazy: true }
    },
    {
      id: 'featuredEpisodePlayer',
      name: 'Featured Episode Player (html iframe)',
      type: 'Text'
    },
    {
      id: 'featuredEpisodeGoogleLink',
      name: 'Featured Episode Google link - url',
      type: 'Symbol',
      validations: [urlValidation]
    },
    {
      id: 'featuredEpisodeAppleLink',
      name: 'Featured Episode Apple link - url',
      type: 'Symbol',
      validations: [urlValidation]
    },
    {
      id: 'featuredEpisodeSpotifyLink',
      name: 'Featured Episode Spotify link - url',
      type: 'Symbol',
      validations: [urlValidation]
    },
    {
      id: 'exploreAllEpisodesGallery',
      name: 'Explore all Episodes Gallery',
      type: 'BlockMediaCardGroup',
      imageOptions: { sizes: imageSizes.columns4_169, lazy: true }
    },
    {
      id: 'form',
      name: 'Form',
      type: 'BlockForm'
    },
    {
      id: 'contentBlock',
      name: 'Extra Content',
      type: 'BlockContent'
    }
  ]
}

export const PagePodcastDetail: Definition = {
  contentType: 'PagePodcastDetail',
  fields: [
    {
      id: 'parent',
      name: 'Podcast overview page',
      type: 'PagePodcastOverview',
      required: true
    },
    {
      id: 'hero',
      name: 'Hero',
      type: 'BlockContent',
      imageOptions: { sizes: imageSizes.columns5_34 }
    },
    {
      id: 'previousLink',
      name: 'Previous Link',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'nextLink',
      name: 'Next Link',
      type: 'ModuleNavigationLink'
    },
    {
      id: 'episodePlayer',
      name: 'Episode Player (html iframe)',
      type: 'Text'
    },
    {
      id: 'googleLink',
      name: 'Google link - url',
      type: 'Symbol',
      validations: [urlValidation]
    },
    {
      id: 'appleLink',
      name: 'Apple link - url',
      type: 'Symbol',
      validations: [urlValidation]
    },
    {
      id: 'spotifyLink',
      name: 'Spotify link - url',
      type: 'Symbol',
      validations: [urlValidation]
    },
    {
      id: 'speakersTitle',
      name: 'Speakers Title',
      type: 'Symbol'
    },
    {
      id: 'speakersItems',
      name: 'Speakers Items',
      type: 'BlockGroup',
      subType: 'BlockContent',
      imageOptions: { sizes: imageSizes.event_speakers }
    },
    {
      id: 'exploreAllEpisodesTitle',
      name: 'Explore all episodes title',
      type: 'Symbol'
    },
    {
      id: 'exploreAllEpisodesGallery',
      name: 'Explore all episodes Gallery',
      type: 'BlockMediaCardGroup',
      imageOptions: {
        lazy: true,
        sizes: imageSizes.columns12_169
      }
    },
    {
      id: 'form',
      name: 'Form',
      type: 'BlockForm'
    },
    {
      id: 'contentBlock',
      name: 'Extra Content - Content with logo bar',
      type: 'BlockLogoBar'
    },
    {
      id: 'transcriptTitle',
      name: 'Transcript Title',
      type: 'Symbol'
    },
    {
      id: 'transcriptText1',
      name: 'Transcript Text 1',
      type: 'RichText'
    },
    {
      id: 'transcriptText2',
      name: 'Transcript Text 2',
      type: 'RichText'
    }
  ]
}

export default {
  PagePodcast,
  PagePodcastOverview,
  PagePodcastDetail
}
